﻿import { LoginUserModel, AppConstantModel } from "./index";
export class UserCustomerInputModel {

    LoginUserModel: LoginUserModel;
    AppConstantModel: AppConstantModel
}